import Vue from 'vue'

import Button from '@/components/button/basic-button.vue'
import Modal from '@/components/modal/modal.vue'

interface Data {
  selected: number[]
}

export default Vue.extend({
  props: {
    contents: {
      type: Array as Prop<model.Content[]>
    },
    loading: {
      type: Boolean as Prop<boolean>,
      default: false
    }
  },

  components: {
    'v-button': Button,
    'modal': Modal
  },

  data (): Data {
    return {
      selected: []
    }
  },

  mounted () {
    this.selected = this.contents.filter(c => c.is_bookmarked).map(c => c.id)
  },

  methods: {
    handleClickUpdate () {
      this.$emit('update-bookmark', this.contents.filter(c => this.selected.includes(c.id)))
    },

    handleClickClose () {
      this.$emit('close')
    }
  }
})
